import { Fragment, type ReactNode } from "react";
import { Link } from "react-router-dom";
import { isSafeHref } from "@/lib/blog/schema";

// Deliberately limited markdown. React escapes text; HTML is never interpreted.
export function InlineText({ text }: { text: string }) {
  const parts: ReactNode[] = [];
  const tokens = /\*\*(.+?)\*\*|\[([^\]]+)\]\(([^)]+)\)/g;
  let end = 0;
  let match: RegExpExecArray | null;
  while ((match = tokens.exec(text))) {
    parts.push(text.slice(end, match.index));
    const [, bold, label, href] = match;
    const key = match.index;
    if (bold) parts.push(<strong key={key} className="font-semibold text-foreground"><InlineText text={bold} /></strong>);
    else if (!isSafeHref(href)) parts.push(match[0]);
    else {
      const className = "text-primary underline underline-offset-4 decoration-primary/40 hover:decoration-primary transition-colors";
      parts.push(href.startsWith("/")
        ? <Link key={key} to={href} className={className}><InlineText text={label} /></Link>
        : <a key={key} href={href} className={className} target="_blank" rel="noopener noreferrer"><InlineText text={label} /></a>);
    }
    end = tokens.lastIndex;
  }
  parts.push(text.slice(end));
  return <>{parts.map((part, i) => <Fragment key={i}>{part}</Fragment>)}</>;
}
